// extracted by mini-css-extract-plugin
module.exports = {"Date_component":"DateIcon_Date_component__3osYI","NewsEvent_itemCalText":"DateIcon_NewsEvent_itemCalText__2Q3e8"};